import { useCallback, useEffect, useRef } from "react"

// Revue 6 (M2) : les liens médias sont signés et expirent (12-24 h, GE-64).
// Une fiche ouverte longtemps se relit :
// - à la 1re erreur de chargement d'une vignette (une fois par fiche) ;
// - au retour sur l'onglet si elle a été chargée il y a plus de 6 h.
// Jamais sur une fiche aux modifications non sauvegardées (`peutRelire`).
const AGE_MAX_MS = 6 * 3600 * 1000

export default function useRelectureMedias(id, peutRelire, relire) {
	const charge = useRef({ id: null, le: 0, relue: false })
	if (charge.current.id !== id)
		charge.current = { id, le: Date.now(), relue: false }
	const ref = useRef({ peutRelire, relire })
	ref.current = { peutRelire, relire }

	const relireMaintenant = useCallback(() => {
		const { peutRelire: ok, relire: fn } = ref.current
		if (!charge.current.id || !ok) return
		charge.current = { ...charge.current, le: Date.now(), relue: true }
		fn(charge.current.id)
	}, [])

	useEffect(() => {
		const auRetour = () => {
			if (
				document.visibilityState === "visible" &&
				Date.now() - charge.current.le > AGE_MAX_MS
			)
				relireMaintenant()
		}
		document.addEventListener("visibilitychange", auRetour)
		return () => document.removeEventListener("visibilitychange", auRetour)
	}, [relireMaintenant])

	// onError d'une <img> / <video> : une seule relecture par fiche.
	return useCallback(() => {
		if (!charge.current.relue) relireMaintenant()
	}, [relireMaintenant])
}
